var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EmployeeArchivedTable',{attrs:{"items":_vm.items,"is-busy":_vm.isBusyStore,"pagination":_vm.pagination},on:{"changePage":_vm.handlePageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }